// extracted by mini-css-extract-plugin
export default {"tableTitleCell":"GroupWorkPlaceInformation_tableTitleCell__qcH8x","dataClassCell":"GroupWorkPlaceInformation_dataClassCell__rPEP8"};